var map = {
	"./": 12,
	"./development": 255,
	"./development.js": 255,
	"./index": 12,
	"./index.js": 12,
	"./local": 256,
	"./local.js": 256,
	"./production": 257,
	"./production.js": 257,
	"./staging": 258,
	"./staging.js": 258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421;